
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-atlas/[tab]",
      function () {
        return require("private-next-pages/ai-atlas/[tab].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-atlas/[tab]"])
      });
    }
  